/** Sidebar / tour coordination for nav spotlight steps. */

export const CADRINO_EXPAND_SHIFTS_NAV = 'cadrino:expand-shifts-nav';
export const CADRINO_OPEN_MOBILE_NAV = 'cadrino:open-mobile-nav';

/**
 * Anchors under the collapsible Smene accordion.
 * Operativa Issues/Corrections reuse nav-shift-* ids but are NOT nested in Smene.
 */
export function isSmeneNestedNavAnchor(anchor: string): boolean {
  if (anchor === 'nav-time-off-balances') return true;
  if (!anchor.startsWith('nav-shift-')) return false;
  // Operativa Issues / Corrections / Leave are not under the Smene accordion.
  return (
    anchor !== 'nav-shift-reviews' &&
    anchor !== 'nav-shift-adjustments' &&
    anchor !== 'nav-shift-leave'
  );
}

export function prepareNavForTourAnchor(anchor: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CADRINO_OPEN_MOBILE_NAV));
  if (isSmeneNestedNavAnchor(anchor)) {
    window.dispatchEvent(new CustomEvent(CADRINO_EXPAND_SHIFTS_NAV));
  }
}

export type TourMissingReason = 'generic' | 'shifts' | 'crews' | 'policies' | 'nav' | 'timeOff';

export function missingReasonForAnchor(anchor: string): TourMissingReason {
  if (
    anchor === 'nav-shift-reviews' ||
    anchor === 'nav-shift-adjustments' ||
    anchor === 'nav-shift-schedule' ||
    anchor === 'nav-shift-exceptions' ||
    anchor === 'nav-shift-pay-periods' ||
    anchor === 'nav-shift-templates' ||
    anchor === 'nav-shift-reports' ||
    anchor === 'nav-shift-rotations' ||
    anchor === 'nav-shift-audit' ||
    anchor === 'nav-shift-work-rules' ||
    anchor === 'nav-shift-holidays'
  ) {
    return 'shifts';
  }
  if (
    anchor === 'nav-shift-leave' ||
    anchor === 'nav-time-off-balances' ||
    anchor === 'nav-my-leave' ||
    anchor === 'leave-queue-header' ||
    anchor === 'leave-queue-table' ||
    anchor === 'leave-balances-header' ||
    anchor === 'leave-balances-table' ||
    anchor === 'my-leave-header' ||
    anchor === 'my-leave-list' ||
    anchor === 'my-leave-balances' ||
    anchor === 'request-leave-form' ||
    anchor === 'request-leave-submit' ||
    anchor === 'work-rules-time-off-tab' ||
    anchor === 'features-time-off'
  ) {
    return 'timeOff';
  }
  if (anchor === 'nav-shift-crews') return 'crews';
  if (anchor === 'nav-assignment-policies') return 'policies';
  if (anchor.startsWith('nav-')) return 'nav';
  return 'generic';
}

export function tourMissingMessageKey(reason: TourMissingReason): string {
  switch (reason) {
    case 'shifts':
      return 'tourAnchorMissingShifts';
    case 'crews':
      return 'tourAnchorMissingCrews';
    case 'policies':
      return 'tourAnchorMissingPolicies';
    case 'nav':
      return 'tourAnchorMissingNav';
    case 'timeOff':
      return 'tourAnchorMissingTimeOff';
    default:
      return 'tourAnchorMissing';
  }
}
